import { I18n } from "react-redux-i18n";
import { formatApproverInfo } from "../../util/FormatUtil";


export const independentHandlingPermStatus = (applicant, isTeacher) => {
  const {
    independentHandlingApproveDate,
    independentHandlingApprover,
    independentHandlingPerm,
  } = applicant;

  const label = independentHandlingPerm
    ? [
        I18n.t("applicant.independent_handling_approved"),
        formatApproverInfo(
          independentHandlingApproveDate,
          independentHandlingApprover
        ),
      ].join(", ")
    : I18n.t("applicant.independent_handling_eligible");
  const disabled = !isTeacher;
  return {
    hasPermission: independentHandlingPerm,
    label,
    disabled: disabled,
    disabledInfo: disabled
      ? I18n.t("applicant.person_transport_perm_disabled_not_teacher")
      : "",
  };
};


// WEBPACK FOOTER //
// ./src/components/applicant/independentHandlingPermStatus.js